import classNames from 'classnames';
import React from 'react';
import './Flyout.scss';

export default function Flyout({ className, innerRef, ...props }: React.HTMLAttributes<HTMLDivElement> & { innerRef?: React.Ref<HTMLDivElement> }) {
  return <div ref={innerRef} className={classNames('Flyout', className)} {...props} />
}
